export default {"src":"/_next/static/media/co-ownership-logo-white.71640ab2.svg","height":70,"width":290,"blurWidth":0,"blurHeight":0};